import axios from "axios";

const api = axios.create({
  baseURL: "https://api.heyatyolu.az/api",
  withCredentials: true,
});


let hasRedirected = false;

api.interceptors.response.use(
  (response) => {
    // Əgər cavab uğurludursa, redirect blokunu sıfırla
    hasRedirected = false;
    return response;
  },
  (error) => {
    if (
      error.response?.status === 401 &&
      !hasRedirected &&
      window.location.pathname !== "/giris"
    ) {
      hasRedirected = true;
      // window.location.href = "/giris";
    }
    return Promise.reject(error);
  }
);

export default api;
